import { IAppState } from '../../redux';
import { EMoneySource } from '../../redux/reducers';

export function selectUserMoneySource(state: IAppState): EMoneySource | null {
  return state.user.moneySource || null;
}
